import type { ResponseGetCdtCategoryStores } from "@CommonApi/cdt/categories/_categoryId_/stores";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { fetchCdtCategoryStores } from "./cdtTreeService";

export const CDT_CATEGORY_STORES_QUERY_KEY = (categoryId?: number) =>
  ["cdt-category-stores", categoryId] as const;

export const useCdtCategoryStoresQuery = (
  categoryId?: number,
): UseQueryResult<ResponseGetCdtCategoryStores> =>
  useQuery({
    queryKey: CDT_CATEGORY_STORES_QUERY_KEY(categoryId),
    queryFn: () => {
      if (categoryId === undefined) throw new Error("CategoryId is required");
      return fetchCdtCategoryStores(categoryId);
    },
    enabled: categoryId !== undefined && categoryId > 0,
  });
